import { createApiActionTypes } from 'store';

export const GET_RESPONDENT_DATA = createApiActionTypes('GET_RESPONDENT_DATA');
export const GET_MODULE_GENERAL_INFO = createApiActionTypes(
	'GET_MODULE_GENERAL_INFO',
);
export const GET_MODULE_RATINGS = createApiActionTypes('GET_MODULE_RATINGS');
export const GET_MODULE_EVALUATION = createApiActionTypes(
	'GET_MODULE_EVALUATION',
);

export const GET_FINISH_MODULE = createApiActionTypes('GET_FINISH_MODULE');
export const GET_FINISH_SECOND_MODULE = createApiActionTypes(
	'GET_FINISH_SECOND_MODULE',
);

export const POST_SURVEY_DATA = createApiActionTypes('POST_SURVEY_DATA');

export const SET_ACTIVE_MODULE = 'SET_ACTIVE_MODULE';
export const SET_PROGRESS = 'SET_PROGRESS';
export const RESET_FINISH_MODULE = 'RESET_FINISH_MODULE';
export const FINISH_SURVEY = 'FINISH_SURVEY';
